import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { openURLbyTarget } from '../../utils/openURLbyTarget';
import { setFrequencyCapping } from '../../utils/frequencyCapping';
import withBraze from '../../utils/withBraze';
import placements from '../../Placements';
import { SlideUpBanner } from '../../components/SlideUpBanner';
import style from './SlideUpWrapper.css';
const PLACEMENT = placements.SLIDE_UP;
const SlideUp = ({ payload: { messageDuration, url, message, campaignId, openTarget, clickAction, imageUrl, buttonText, dismissType, }, close, section, trackingLibrary, }) => {
    const onSlideUpClick = () => {
        trackingLibrary === null || trackingLibrary === void 0 ? void 0 : trackingLibrary.trackInAppMessageClick(PLACEMENT, campaignId);
        if (clickAction === 'URI' && url) {
            openURLbyTarget(url, openTarget);
        }
        close();
    };
    const onSlideUpContentShown = () => {
        trackingLibrary === null || trackingLibrary === void 0 ? void 0 : trackingLibrary.trackInAppMessageImpression(PLACEMENT, campaignId);
        setFrequencyCapping(section, PLACEMENT);
    };
    React.useEffect(onSlideUpContentShown, [campaignId]);
    return (_jsx(SlideUpBanner, { handleOnClose: close, text: message, timeout: messageDuration, buttonText: buttonText, onButtonClick: onSlideUpClick, iconURL: imageUrl, classNameWrapper: style.slideUpWrapper, autoDismiss: dismissType === 'AUTO_DISMISS' }));
};
const SlideUpConsumer = withBraze(PLACEMENT)(SlideUp);
export { SlideUpConsumer, SlideUp };
//# sourceMappingURL=SlideUpConsumer.js.map